var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenCashDrawer = function SvgOpenCashDrawer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.555 14.1188C31.8459 14.5916 32 15.1359 32 15.6911V22C32 23.6569 30.6569 25 29 25H3C1.34315 25 0 23.6569 0 22V15.6911C0 15.1359 0.154057 14.5916 0.445024 14.1188L4.56262 7.42771C5.10861 6.54047 6.07581 6 7.11759 6H24.8824C25.9242 6 26.8914 6.54046 27.4374 7.42771L31.555 14.1188ZM26 19.5C26 18.6716 26.6716 18 27.5 18C28.3284 18 29 18.6716 29 19.5C29 20.3284 28.3284 21 27.5 21C26.6716 21 26 20.3284 26 19.5ZM24.8824 8C25.2297 8 25.5521 8.18016 25.7341 8.4759L29.7489 15H2.2511L6.26593 8.4759C6.44793 8.18015 6.77032 8 7.11759 8H24.8824Z",
    fill: "currentColor"
  })));
};
export default SvgOpenCashDrawer;